import { useExamStore } from '@/store/ExamStore/ExamStore';
import { useSeriesStore } from '@/store/SeriesStore/SeriesStore';
import { useGetSeries } from '@/api/hooks/useSerie';
import { useGetDiscplines } from '@/api/hooks/useDiscipline';
import { useCreateExercise, useUpdateExercise } from '@/api/hooks/useExercise';
import { useToast } from '@/hooks/useToast';
import { useGetExercisesWithDisciplinesAndSeries } from '@/api/hooks/useExercisesWithDisciplinesAndSeries';
import { ExerciseInput } from '@/api/gql/graphql';
import { Options } from '@/components/Common/Selects/Select.types';
import { TestFormValues, useTestForm } from '../../../hooks/useTestForm';
import { useSettingUpTests } from './SettingUpTest.hook';
import { useState } from 'react';

export type idExercise = {
  id: string;
};
export const useAddTest = ({ id }: idExercise) => {
  const { selectedExercise } = useSettingUpTests();
  const [selectedDiscipline, setSelectedDiscipline] = useState<Options | null>(
    null,
  );
  const [selectedSeries, setSelectedSeries] = useState<Options[]>([]);
  const { isOpenExamModal, setIsOpenExamModal, editingTab, setEditingTab } =
    useExamStore();
  const { mutate: createExercise } = useCreateExercise();
  const { mutate: updateExercise } = useUpdateExercise();

  const { showToast } = useToast();
  const { setSelectedSerieValues } = useSeriesStore();
  const { data: series } = useGetSeries({ classes: null, name: null });
  const { data: disciplines } = useGetDiscplines();
  const { data: exercises } = useGetExercisesWithDisciplinesAndSeries();
  const { register, handleSubmit, errors, setValue, reset } = useTestForm();
  const handleCloseModal = () => {
    setIsOpenExamModal(false);
    setEditingTab(false);
  };

  const handleChangeSeries = (values: Options[]) => {
    setSelectedSerieValues(values);
  };

  const handleUpdateExercise = (data: TestFormValues) => {
    const updatedExercise: ExerciseInput = {
      discipline: data.subject,
      series: data.series?.map((serie) => serie._id),
      name: data.name,
      position: data.position,
      duration: String(data.duration),
    };

    updateExercise(
      {
        id,
        input: updatedExercise,
      },
      {
        onSuccess: () => {
          showToast('Exercice mis à jour avec succès', 'success');
          handleCloseModal();
          reset();
          setValue('series', []);
          setValue('subject', '');
          setSelectedDiscipline(null);
          setSelectedSeries([]);
        },
        onError: (error) => {
          showToast(error.message, 'error');
        },
      },
    );
  };

  const handleCreateExercise = (data: TestFormValues) => {
    const newExercise: ExerciseInput = {
      discipline: data.subject,
      series: data.series?.map((serie) => serie._id),
      name: data.name,
      position: data.position,
      duration: String(data.duration),
      questions: null,
    };

    createExercise(newExercise, {
      onSuccess: () => {
        showToast('Exercice créé avec succès', 'success');
        handleCloseModal();
        reset();
        setValue('series', []);
        setValue('subject', '');
        setSelectedDiscipline(null);
        setSelectedSeries([]);
      },
      onError: (error) => {
        showToast(error.message, 'error');
      },
    });
  };

  return {
    isOpenExamModal,
    editingTab,
    series,
    disciplines,
    exercises,
    handleCloseModal,
    handleChangeSeries,
    handleCreateExercise,
    handleUpdateExercise,
    selectedExercise,
    register,
    handleSubmit,
    errors,
    setValue,
    reset,
    selectedDiscipline,
    setSelectedDiscipline,
    selectedSeries,
    setSelectedSeries,
  };
};
